module.exports = __webpack_public_path__ + "img/site-empty-search.1bf14913.png";